import { Field } from '../../../components/ui';
import { useLoi } from '../../../hooks/useLoi';
import { useT } from '../../../i18n';
import { useCayPhongBan } from '../hooks/usePhongBan';
import { CayChonPhongBan } from './CayChonPhongBan';

/**
 * Ô chọn phòng ban cho hộp mời và hộp sửa người dùng (`department_id` của
 * `POST /api/v1/users/invite`, `PATCH /api/v1/users/{id}`; ADR-0014).
 *
 * Chọn trên cây (`CayChonPhongBan`), để hai "Phòng Kinh doanh" ở hai khối khác
 * nhau không lẫn. Không tải được cây thì ô báo lỗi ngay dưới nó và khoá
 * lại, phần còn lại của form vẫn lưu được; giá trị đang có giữ nguyên.
 */
export function ChonPhongBan({
  value,
  onChange,
  error,
}: {
  value: string | null;
  onChange: (id: string | null) => void;
  /** Lỗi của server cho trường này, ví dụ `404 DEPARTMENT_NOT_FOUND`. */
  error?: string;
}) {
  const { t } = useT();
  const dichLoi = useLoi();
  const q = useCayPhongBan();
  const loiTai = q.error && !q.data ? t('nguoiDung.fPhongBanLoi', { loi: dichLoi(q.error) }) : undefined;

  return (
    <Field label={t('nguoiDung.fPhongBan')} error={error ?? loiTai}>
      {(p) => (
        <CayChonPhongBan
          fieldProps={p}
          ds={q.data ?? []}
          loading={q.isLoading}
          disabled={Boolean(loiTai)}
          placeholder={t('nguoiDung.fPhongBanTrong')}
          khongCo={t('nguoiDung.fPhongBanKhongCo')}
          // Chưa tải xong cây thì chưa có nhãn: đừng hiện id thô.
          value={q.data ? value : null}
          onChange={onChange}
        />
      )}
    </Field>
  );
}
